import jquery from 'jquery'

window.$ = jquery
window.jQuery = jquery